import { CompilerComponent } from '@types';

import { PieChartParts } from '@application/lib/defaultTheme';

import { block } from './block';
import { component } from './component';
import { defaultProps, protocolFactory } from './protocol';

export interface PieChartProps {
  chartCategory: string;
  chartCategoryLabel: string;
  chartValue: string;
  chartValueLabel: string;
  chartData: {
    [key: string]: string | number;
  }[];
}

export default {
  component,
  block,
  defaultProps,
  protocolFactory,
} as CompilerComponent<PieChartProps, PieChartParts>;
